import { c as _c } from "react/compiler-runtime";
import { Heading } from '../../../components/Heading';
import styles from './ModalContent.module.css';
export type PostCodeLotteryInfoText = {
  heading: string;
  description_start: string;
  post_code_lottery: string;
  description_end: string;
};
function PostCodeLotteryInfo(t0) {
  const $ = _c(11);
  const {
    text
  } = t0;
  let t1;
  if ($[0] !== text.heading) {
    t1 = <Heading as="h3" level="text-md-important">{text.heading}</Heading>;
    $[0] = text.heading;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text.post_code_lottery) {
    t2 = <strong>{text.post_code_lottery}</strong>;
    $[2] = text.post_code_lottery;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2 || $[5] !== text.description_end || $[6] !== text.description_start) {
    t3 = <p>{text.description_start}{t2}{text.description_end}</p>;
    $[4] = t2;
    $[5] = text.description_end;
    $[6] = text.description_start;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <div className={styles.paragraph}>{t1}{t3}</div>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
}
export default PostCodeLotteryInfo;